export default __webpack_public_path__ + "static/media/cerrar_conbg.1a282221.svg";